import React, { useEffect, useRef } from "react";
import QRCode from "qrcode";

/**
 * Renders `value` as a scannable QR code on an inline <canvas>.
 *
 * QR codes are used instead of a linear (CODE128) barcode because the boarding-pass
 * payload is long free text — packed into a thin 1D barcode it becomes too dense to
 * scan reliably at print/screen size. A QR code stays scannable even when small, and
 * any generic phone camera / QR reader will show `value` back verbatim as the result.
 */
const BarcodeGenerator = ({
  value,
  size = 90,
  className = "",
  style = {},
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current || !value) return;
    QRCode.toCanvas(canvasRef.current, value, {
      width: size,
      margin: 1,
      errorCorrectionLevel: "M",
    }).catch((err) => {
      console.error("QR code generation failed for value:", value, err);
    });
  }, [value, size]);

  if (!value) return null;

  return (
    <canvas
      ref={canvasRef}
      className={className}
      style={{ width: size, height: size, ...style }}
    />
  );
};

export default BarcodeGenerator;
